"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertManager = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var AlertManagerContext_1 = require("./AlertManagerContext");
var AlertManager_styled_1 = require("./AlertManager.styled");
var DpAlert_1 = require("./DpAlert");
var AlertManagerContextState_1 = require("./AlertManagerContextState");
/**
 * AlertManager
 * Displays and removes all alerts
 *
 * @param {ReactNode} children  the whole application
 */
var AlertManager = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)([]), alerts = _b[0], setAlerts = _b[1];
    var publish = function (alert) {
        setAlerts(__spreadArray(__spreadArray([], alerts, true), [alert], false));
    };
    var remove = function (removeId) {
        if (removeId) {
            setAlerts(alerts.filter(function (alert) { return alert.id !== removeId; }));
        }
        else {
            setAlerts(alerts.splice(0, 1));
        }
    };
    var removeAlert = function (removeId) { return function () {
        remove(removeId);
    }; };
    return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    (0, jsx_runtime_1.jsxs)(AlertManagerContext_1.AlertManagerContext.Provider, { value: new AlertManagerContextState_1.AlertManagerContextState({ publish: publish, remove: remove }), children: [children, !(0, isEmpty_1.default)(alerts) && ((0, jsx_runtime_1.jsx)(AlertManager_styled_1.StyledAlertManager, { children: alerts.map(function (_a) {
                    var id = _a.id, alert = _a.alert;
                    return ((0, jsx_runtime_1.jsx)(DpAlert_1.DpAlert
                    // @ts-ignore
                    , __assign({ onClose: removeAlert(id) }, alert), id));
                }) }))] }));
};
exports.AlertManager = AlertManager;
exports.default = exports.AlertManager;
